export const global_breakpoint_2xl = {
  "name": "--pf-v5-global--breakpoint--2xl",
  "value": "1450px",
  "var": "var(--pf-v5-global--breakpoint--2xl)"
};
export default global_breakpoint_2xl;